<template>
  <dropdown :close-on-click="true">
    <template slot="btn"
      ><country-flag :country="language.code === 'en' ? 'us' : language.code" size="small" />&nbsp;</template
    >
    <template slot="body">
      <div
        v-for="lang in languageService.getSupportedLanguages()"
        :key="lang.code"
        @click="handleClick"
        :data-value-code="lang.code"
      >
        <country-flag :country="lang.code === 'en' ? 'us' : lang.code" size="small" />&nbsp;{{ lang.caption }}
      </div>
    </template>
  </dropdown>
</template>

<script>
import Dropdown from 'bp-vuejs-dropdown';
import languageService from '../services/LanguageService';

export default {
  name: 'LanguageSwitcher',
  components: {
    Dropdown,
  },
  data: () => ({
    languageService,
    language: languageService.getLanguage(),
  }),
  methods: {
    handleClick(event) {
      const { valueCode } = event.target.dataset;
      this.language = this.languageService.setLanguage(valueCode);
      const { path } = this.$route;
      // let route = this.language.code !== 'de' ? `/${this.language.code}` : '';
      // route += path.split('/')[1].length === 2 ? `/${path.replace(/^[/a-zA-Z]{3}/i, '')}` : `/${path}`;
      this.$router.push(this.language.code !== 'de' ? `/${this.language.code}` : '/'); //route);
      this.$router.go(0);
    },
  },
};
</script>

<style>
.bp-dropdown {
  height: 30px !important;
  color: black !important;
  font-weight: 600;
  background-color: white;
  border-radius: 5px;
}

.bp-dropdown__btn {
  border: none !important;
}

.bp-dropdown__body {
  border: none !important;
}
</style>
